import LoginId               from "../../../domain/authentication/LoginId";
import FetchStatusRepository from "../../../domain/fundamentals/fetch/FetchStatusRepository";
import NotifyRepository      from "../../../domain/fundamentals/message/notify/NotifyRepository";
import FirstName             from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana         from "../../../domain/fundamentals/name/FirstNameKana";
import LastName              from "../../../domain/fundamentals/name/LastName";
import LastNameKana          from "../../../domain/fundamentals/name/LastNameKana";
import Name                  from "../../../domain/fundamentals/name/Name";
import Staff                 from "../../../domain/staff/Staff";
import StaffId               from "../../../domain/staff/StaffId";
import StaffMemo             from "../../../domain/staff/StaffMemo";
import StaffRepository       from "../../../domain/staff/StaffRepository";
import Staffs                from "../../../domain/staff/Staffs";
import FetchStatusDataSource from "../../../infrastructure/datasource/common/fetch/FetchStatusDataSource";
import NotifyDataSource      from "../../../infrastructure/datasource/notify/NotifyDataSource";
import StaffDataSource       from "../../../infrastructure/datasource/staff/StaffDataSource";

class GetStaffs {
  constructor(
    private readonly dispatch,
    private readonly staffRepository: StaffRepository = new StaffDataSource(dispatch),
    private readonly fetchStatusRepository: FetchStatusRepository = new FetchStatusDataSource(dispatch),
    private readonly notifyRepository: NotifyRepository = new NotifyDataSource(dispatch),
  ) {
  }

  public async execute() {
    this.fetchStatusRepository.start();
    try {
      const response = await this.staffRepository.findAll();
      const list: Staff[] = response.data.staffs.map(staff =>
        new Staff(
          new StaffId(staff.id),
          new Name(new LastName(staff.last_name), new FirstName(staff.first_name), new LastNameKana(staff.last_name_kana), new FirstNameKana(staff.first_name_kana)),
          staff.gender,
          new StaffMemo(staff.memo),
          LoginId.of(staff.login_id),
        )
      );
      this.staffRepository.setStaffs(new Staffs(list));
    } catch (e) {
      this.notifyRepository.fetchFailure();
    } finally {
      this.fetchStatusRepository.finish();
    }
  }
}

export default GetStaffs;
